/*@flow*/
import { createStore, applyMiddleware } from 'redux';
import reducer from './reducer';
import thunkMiddleware from './middleware/thunk';
import * as I from 'immutable';

const init = I.Map();

const middlewares = applyMiddleware(thunkMiddleware);
const store = createStore(reducer, init, middlewares);
export default store;
